<template>
    <div>
        <Header title="小组管理">
            <template v-slot:content>
                <div style="display: flex">
                    <div style="flex:1">
                    </div>
                    <div>
                        <Button @click="target()">目标</Button>
                        <Button type="primary" style="margin-left:10px" @click="add()">新增</Button>
                    </div>

                </div>
            </template>
        </Header>
        <div class="my-white-mod">
            <PageTable :loading="table.loading" :columns="table.columns" :size="table.limit" :data="table.data" :current="table.current" :total="table.total"  @switchPage="changepage"  >
            </PageTable>
        </div>
        <Modal
                :mask-closable="false"
                v-model="show_success"
                :title="title"
                width="400"
                @on-ok="update_team"
        >
            <div class="modal-title">小组名称</div>
            <Input  placeholder="请填小组名称" v-model="submit_form.name" />
<!--            <div class="modal-title modal-title-two">选择员工</div>-->
<!--            <Select  multiple  placeholder="请选择员工" >-->
<!--                <Option v-for="item in cityList" :value="item.value" :key="item.value">{{ item.label }}</Option>-->
<!--            </Select>-->
        </Modal>
        <Modal
                :mask-closable="false"
                v-model="show_del"
                title="删除"
                width="400"
                @on-ok="delete_team"
        >
            <div  class="my-modal-del">
                <Icon type="ios-alert"  />
                是否删除该小组
            </div>
        </Modal>

        <Modal
                :mask-closable="false"
                v-model="show_team"
                title="小组成员"
                width="600">
            <Button type="primary" style="margin-left:10px" @click="add_member()">新增</Button>
            <PageTable :loading="team_table.loading"   :columns="team_table.columns" :size="team_table.limit" :data="team_table.data" :current="team_table.current" :total="team_table.total"  @switchPage="changeteampage" >
            </PageTable>
            <div slot="footer"></div>
        </Modal>
        <Modal
                :mask-closable="false"
                v-model="show_team_add"
                :title="title"
                width="400"
                @on-ok="update_team_member"
        >
            <div class="modal-title modal-title-two">选择员工</div>
            <Select    placeholder="请选择员工" filterable v-model="team_form.department_member_id"  >
                <Option v-for="(item, index) in departmentList" :value="item.id" :key="index">{{item.platform_name}}-{{ item.name }}</Option>
            </Select>
        </Modal>
        <Modal
                :mask-closable="false"
                v-model="show_member_del"
                title="删除"
                width="400"
                @on-ok="delete_team_member"
        >
            <div class="my-modal-del">
                <Icon type="ios-alert" />
                是否删除该员工
            </div>
        </Modal>

        <Modal
                :mask-closable="false"
                v-model="show_target"
                title="目标"
                width="600">
            <Button type="primary" style="margin-left:10px" @click="add_target()">新增</Button>
            <PageTable :loading="target_table.loading"  :columns="target_table.columns"  :size="target_table.limit"  :data="target_table.data" :current="target_table.current" :total="target_table.total"  @switchPage="changetargetpage"  >
            </PageTable>
            <div slot="footer"></div>
        </Modal>
        <Modal
                :mask-closable="false"
                v-model="show_target_add"
                :title="target_title"
                width="400"
        >
            <div class="modal-title">新增任务</div>
            <Input  placeholder="请填任务金额" v-model="target_form.target_money" />
            <div class="modal-title modal-title-two">目标日期</div>
            <DatePicker  v-model="target_form.month" @on-change="changeMonth" format="yyyy-MM" type="month" placement="top-start" placeholder="选择日期" ></DatePicker>

            <div slot="footer">
                <Button  type="primary"  @click="update_target_manager">确定</Button >
            </div>
        </Modal>
        <Modal
                :mask-closable="false"
                v-model="show_target_del"
                title="删除"
                width="400"
                @on-ok="delete_target"
        >
            <div class="my-modal-del">
                <Icon type="ios-alert" />
                是否删除该任务
            </div>
        </Modal>

        <Modal
                :mask-closable="false"
                v-model="show_target_share"
                title="分配目标"
                width="400"
                @on-ok="sumit_target_money"
        >
            <div class="modal-title">目标日期：{{share_target_form.month}}</div>
            <div class="modal-title modal-title-two">总目标：￥{{share_target_form.money}}</div>
            <div v-for="(item, i) in team_target_arr"  :key="i" style="border:1px solid #eee;padding:10px;margin: 10px 0">
                <div class="modal-title modal-title-two" >{{item.name}}的目标</div>
                <Input  placeholder="请填写金额" v-model="item.target_money" />
                <div style="display: flex;align-items: center;justify-content: space-around;flex-wrap: wrap;">
                    <div v-for="(it, k) in item.team_member" :key="k" :id="it.id"   >
                            <div class="modal-title modal-title-two" >{{it.department_member_name}}</div>
                            <Input style="width:100px" placeholder="请填写金额" v-model="it.target_money" />
                    </div>
                </div>

            </div>
        </Modal>
    </div>

</template>
<script>
    import {team_list, team_manager, team_del,team_department_list,team_member_list, team_member_manager,team_member_del, target_list, target_manager,target_del, team_target,team_target_manager } from "@/api/system";
    import {Header, PageTable} from "@/components/mainLayout"
    import moment from "moment"

    export default {
        components:{
            Header,
            PageTable
        },
        data(){
            return{
                target_title:"新增",
                title:"新增",
                show_success:false,
                show_del:false,
                show_team_add:false,
                show_team:false,
                show_member_del:false,
                show_target:false,
                show_target_add:false,
                show_target_del:false,
                show_target_share:false,
                submit_form:{
                    name:""
                },
                team_form:{
                    department_member_id:0,
                    team_id:0
                },
                target_form:{
                    target_money:"",
                    month:""
                },
                share_target_form:{
                    month:"",
                    money:"",
                    data:[]
                },
                departmentList: [],
                delete_id:0,
                table:{
                    current:1,
                    total:0,
                    loading:false,
                    limit:30,
                    columns: [
                        {
                            align:'center',
                            type: 'index'
                        },
                        {
                            title: '组名',
                            align:'center',
                            key: 'name',
                            width:200
                        },
                        {
                            title: '组员',
                            align:'center',
                            key: 'id',
                            render: (h, params) => {
                                let textcolor = params.row.num >0 ? "#3F8CFF" : "#ff0000";
                                return h('div', [
                                    h('Button', {
                                        props: {
                                            type: 'text',
                                            size: 'small'
                                        },
                                        style:{color: textcolor},
                                        on: {
                                            click: () => {
                                                this.team_form.team_id = this.team_table.team_id = params.row.id;
                                                this.get_team_member_list();
                                                this.show_team = true;

                                            }
                                        }
                                    }, params.row.num+"人")
                                ]);

                            }
                        },
                        {
                            title: '创建时间',
                            align:'center',
                            key: 'ctime'
                        },

                        {
                            title: '操作',
                            align:'center',
                            key: 'id',
                            render: (h, params) => {
                                return h('div', [
                                    h('Button', {
                                        props: {
                                            type: 'text',
                                            size: 'small'
                                        },
                                        style:{color:'#3F8CFF'},
                                        on: {
                                            click: () => {
                                                this.edit(params);
                                            }
                                        }
                                    }, '编辑'),
                                    h('Button', {
                                        props: {
                                            type: 'text',
                                            size: 'small'
                                        },
                                        style:{color:'#ff0000'},
                                        on: {
                                            click: () => {
                                                this.del(params);
                                            }
                                        }
                                    }, '删除')
                                ]);

                            }

                        }
                    ],
                    data: []
                },
                team_table:{
                    loading:false,
                    delete_id:0,
                    current:1,
                    total:0,
                    limit:30,
                    team_id:0,
                    columns: [
                        {
                            align:'center',
                            type: 'index'
                        },
                        {
                            title: '员工',
                            align:'center',
                            key: 'name',
                            width:200
                        },
                        {
                            title: '操作',
                            align:'center',
                            render: (h, params) => {
                                return h('div', [
                                    h('span', {
                                        style:{color:'#3F8CFF',cursor:'pointer'},
                                        on: {
                                            click: () => {
                                                this.team_table.delete_id = params.row.id;
                                                this.show_member_del = true;
                                            }
                                        }
                                    }, '删除')
                                ]);

                            }

                        }
                    ],
                    data: []
                },
                team_target_arr:[],
                target_table:{
                    loading:false,
                    delete_id:0,
                    current:1,
                    total:0,
                    limit:30,
                    columns: [
                        {
                            align:'center',
                            type: 'index',
                            width:100
                        },
                        {
                            title: '目标金额',
                            align:'center',
                            key: 'name',
                            render: (h, params) => {
                                return h('div', [
                                    h('span', {
                                        style:{color:'#3F8CFF',cursor:'pointer'},
                                        on: {
                                            click: () => {
                                                this.share_target(params);
                                            }
                                        }
                                    }, '￥'+params.row.target_money)
                                ]);

                            }
                        },
                        {
                            title: '目标日期',
                            align:'center',
                            width:200,
                            key: 'id',
                            render: (h, params) => {
                                return h('div', [
                                    h('span', {}, params.row.month)
                                ]);

                            }
                        },

                        {
                            title: '操作',
                            align:'center',
                            key: 'id',
                            render: (h, params) => {
                                return h('div', [
                                    h('span', {
                                        style:{color:'#3F8CFF',cursor:'pointer'},
                                        on: {
                                            click: () => {
                                                this.edit_target(params);
                                            }
                                        }
                                    }, '编辑'),
                                    h('span', {
                                        style:{color:'#ff0000',cursor:'pointer', margin:'0 0 0 15px'},
                                        on: {
                                            click: () => {
                                                this.target_table.delete_id = params.row.id;
                                                this.del_target();
                                            }
                                        }
                                    }, '删除')
                                ]);

                            }

                        }
                    ],
                    data: []
                }

            }
        },
        mounted(){
            this.list();
            this.get_department_list()
        },
        methods:{
            list(){
                this.table.loading = true
                team_list({limit:this.table.limit, page:this.table.current}).then(res=>{
                    this.table.loading = false
                    if (res.code == 200) {
                        this.table.data = res.data
                        this.table.total = parseInt(res.total)
                    } else {
                        this.table.data = []
                        this.table.total = 0
                        this.$Message.error(res.msg)
                    }
                })
            },
            get_department_list(){
                team_department_list().then(res=>{
                    this.departmentList = res.data
                })
            },
            get_team_member_list(){
                this.team_table.loading = true
                team_member_list({team_id:this.team_table.team_id,limit:this.team_table.limit, page:this.team_table.current}).then(res=>{
                    this.team_table.loading = false
                    if (res.code == 200) {
                        this.team_table.data = res.data
                        this.team_table.total = res.total
                    } else {
                        this.team_table.data = []
                        this.team_table.total = 0
                        this.$Message.error(res.msg)
                    }
                })
            },
            changeteampage(e){
                this.team_table.current = e;
                this.get_team_member_list()
            },

            delete_team(){
                team_del({id:this.delete_id}).then(res=>{
                    if (res.code == 200) {
                        this.list();
                        this.$Message.success(res.msg);
                    } else {
                        this.$Message.error(res.msg);
                    }
                })
            },
            changepage(index){
                this.table.current = index;
                this.list();
            },
            update_team(){
                if (this.submit_form.name == "" ){
                    this.$Message.error("小组名称不能为空");return;
                }
                team_manager(this.submit_form).then(res=>{
                    if (res.code == 200) {
                        this.list();
                        this.$Message.success(res.msg);
                    } else {
                        this.$Message.error(res.msg);
                    }
                })
            },
            update_team_member(){
                console.log(this.team_form)
                if (this.team_form.department_member_id  == "" || this.team_form.department_member_id  == 0 ){
                    this.$Message.error("组员不能为空");return;
                }
                team_member_manager(this.team_form).then(res=>{
                    if (res.code == 200) {
                        this.get_team_member_list();
                        this.$Message.success(res.msg);
                    } else {
                        this.$Message.error(res.msg);
                    }
                })
            },
            delete_team_member(){
                team_member_del({id:this.team_table.delete_id}).then(res=>{
                    if (res.code == 200) {
                        this.get_team_member_list();
                        this.$Message.success(res.msg);
                    } else {
                        this.$Message.error(res.msg);
                    }
                })
            },

            add(){
                this.title = "新增";
                this.show_success = true;
                this.submit_form = {
                    name:""
                }
            },
            edit(e){
                this.title = "编辑";
                this.submit_form = e.row;
                this.show_success = true;
            },
            del(e){
                this.delete_id = e.row.id;
                this.show_del = true;
            },
            add_member(){
                this.show_team_add = true
            },
            target(){
                this.get_target_list();
                this.show_target = true;
            },
            add_target(){
                this.target_form = {
                    target_money:"",
                    month:"",
                };
                this.target_title = "新增";
                this.show_target_add = true;
            },
            del_target(){
                this.show_target_del = true;
            },
            edit_target(e){
                this.target_form =JSON.parse(JSON.stringify(e.row));
                this.show_target_add = true
            },
            share_target(e){
                this.share_target_form.money = e.row.target_money
                this.share_target_form.month = e.row.month
                this.share_target_form.id = e.row.id;
                this.get_team_target();
                this.show_target_share = true;
            },
            get_target_list(){
                this.target_table.loading = true
                target_list({limit:this.target_table.limit, page:this.target_table.current}).then(res=>{
                    this.target_table.loading = false
                    if (res.code == 200) {
                        this.target_table.data = res.data
                        this.target_table.total = res.total
                    } else {
                        this.target_table.data = []
                        this.target_table.total = 0
                        this.$Message.error(res.msg)
                    }
                })
            },
            changetargetpage(e){
                this.target_table.current = e;
                this.get_target_list()
            },
            update_target_manager(){
                if (this.target_form.targetMoney=="") {
                    this.$Message.error("请填写金额");return;
                }
                if (this.target_form.month=="") {
                    this.$Message.error("请选择月份");return;
                }
                this.target_form.month = moment(this.target_form.month).format('YYYY-MM')
                target_manager(this.target_form).then(res=>{
                    if (res.code == 200) {
                        this.show_target_add = false
                        this.get_target_list()
                    } else {
                        this.$Message.error(res.msg);
                    }

                })
            },
            delete_target(){
                target_del({id:this.target_table.delete_id}).then(res=>{
                    if (res.code == 200) {
                        this.get_target_list();
                        this.$Message.success(res.msg);
                    } else {
                        this.$Message.error(res.msg);
                    }
                })
            },
            changeMonth(e){
                this.target_form.month = e;
            },
            get_team_target(){
                team_target({id:this.share_target_form.id}).then(res=>{
                        let that = this;
                        that.team_target_arr = [];
                        res.data.forEach(function(v){
                            if (v.team_id == undefined) {
                                let obj = {"team_id":v.id, target_id: that.share_target_form.id, "name":v.name, 'target_money':0, 'team_member':v.team_member}
                                that.team_target_arr.push(obj)
                            } else {
                                that.team_target_arr.push(v)
                            }

                        })
                })
            },
            sumit_target_money(){
                let sum_money = 0;
                for(let i in this.team_target_arr) {
                    sum_money += parseFloat(this.team_target_arr[i].target_money)
                }
                if (sum_money > this.share_target_form.money) {
                    this.$Message.error("金额分配出错");return false;
                }
                team_target_manager({data:this.team_target_arr}).then(res=>{
                    if (res.code == 200) {
                        this.$Message.success(res.msg);
                    } else {
                        this.$Message.error(res.msg);
                    }
                })
            }
        }
    }
</script>
